webpackJsonp([8],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(152);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

var modules = {};
var files = __webpack_require__(671);

files.keys().forEach(function (path, i) {
  var module = files(path);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(module).forEach(function (lang) {
    modules[lang] = module[lang];
  });
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({ modules: modules }));

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var endpoints = {};
var files = __webpack_require__(670);

files.keys().forEach(function (path) {
  var endpoint = files(path);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(endpoint).forEach(function (x) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(endpoint[x]).forEach(function (y) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(endpoints, y, { value: endpoint[x][y] });
    });
  });
});

/* harmony default export */ __webpack_exports__["a"] = (endpoints);

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_BUSINESS_DATA", function() { return INIT_BUSINESS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_TO_CART", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNT_MODAL", function() { return SET_DISCOUNT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOADING", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE_TAB", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESSES", function() { return SET_BUSINESSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COPY_BILLING_ADDRESS_FROM_DEFAULT", function() { return COPY_BILLING_ADDRESS_FROM_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESS_SID", function() { return SET_BUSINESS_SID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_NEW_USER_TO_LIST", function() { return ADD_NEW_USER_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NEW_USER_ID", function() { return SET_NEW_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MANUFACTURER", function() { return ADD_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_MANUFACTURER", function() { return REMOVE_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_MANUFACTURER_PERCENT", function() { return UPDATE_MANUFACTURER_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISTRIBUTORS", function() { return SET_DISTRIBUTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SALES_REPS", function() { return SET_SALES_REPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT", function() { return ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT", function() { return REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOCATION", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_INFO", function() { return SET_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USERS", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BILLING", function() { return SET_BILLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNTS", function() { return SET_DISCOUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NOTES", function() { return SET_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_NOTE_TO_LIST", function() { return ADD_NOTE_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_PERIOD_DATA", function() { return RESET_PERIOD_DATA; });
var INIT_BUSINESS_DATA = 'INIT_BUSINESS_DATA';
var ADD_TO_CART = 'ADD_TO_CART';
var SET_DISCOUNT_MODAL = 'SET_DISCOUNT_MODAL';
var SET_LOADING = 'SET_LOADING';
var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
var SET_BUSINESSES = 'SET_BUSINESSES';
var COPY_BILLING_ADDRESS_FROM_DEFAULT = 'COPY_BILLING_ADDRESS_FROM_DEFAULT';
var SET_BUSINESS_SID = 'SET_BUSINESS_SID';
var ADD_NEW_USER_TO_LIST = 'ADD_NEW_USER_TO_LIST';
var SET_NEW_USER_ID = 'SET_NEW_USER_ID';
var ADD_MANUFACTURER = 'ADD_MANUFACTURER';
var REMOVE_MANUFACTURER = 'REMOVE_MANUFACTURER';
var UPDATE_MANUFACTURER_PERCENT = 'UPDATE_MANUFACTURER_PERCENT';
var SET_DISTRIBUTORS = 'SET_DISTRIBUTORS';
var SET_SALES_REPS = 'SET_SALES_REPS';
var ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT';
var REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT';
var SET_LOCATION = 'SET_LOCATION';
var SET_INFO = 'SET_INFO';
var SET_USERS = 'SET_USERS';
var SET_BILLING = 'SET_BILLING';
var SET_DISCOUNTS = 'SET_DISCOUNTS';
var SET_NOTES = 'SET_NOTES';
var ADD_NOTE_TO_LIST = 'ADD_NOTE_TO_LIST';
var RESET_PERIOD_DATA = 'RESET_PERIOD_DATA';

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guard_route__ = __webpack_require__(388);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__guard_route__["a" /* default */])(to, from, next);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(103);





/* harmony default export */ __webpack_exports__["default"] = ({
  initBusinessModel: function initBusinessModel(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["INIT_BUSINESS_DATA"]);
  },
  setActiveTab: function setActiveTab(_ref2, tab) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_ACTIVE_TAB"], tab);
  },
  showModal: function showModal(_ref3, modal) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_DISCOUNT_MODAL"], modal);
  },
  addNewUserToList: function addNewUserToList(_ref4, defaultTitleId) {
    var commit = _ref4.commit,
        rootState = _ref4.rootState;

    if (defaultTitleId) {
      commit('admin/ADD_SALES_REPRESENTATIVE', defaultTitleId, { root: true });
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["ADD_NEW_USER_TO_LIST"], defaultTitleId);
    }
  },
  copyBillingAddressFromDefault: function copyBillingAddressFromDefault(_ref5, isBillingSameAsDefault) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var address;
    if (isBillingSameAsDefault) {
      address = state.business.primaryAddress;
    } else {
      address = {
        street: null,
        city: null,
        state: null,
        postalCode: null,
        country: null
      };
    }

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["COPY_BILLING_ADDRESS_FROM_DEFAULT"], address);
  },
  getBusinesses: function getBusinesses(_ref6, data) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getBusinesses(data).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_BUSINESSES"], response.data);
    });
  },
  upsertBusiness: function upsertBusiness(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusiness', show: true });
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertBusiness(state.business).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_BUSINESS_SID"], response.data);

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusiness', show: false });
      });
    });
  },
  upsertBusinessUser: function upsertBusinessUser(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessUser', show: true });

    var promises = state.business.users.map(function (user) {
      user.sid = state.business.sid;

      user.receivesReportsOnly = state.business.receivesReportsOnly || false;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertBusinessUser(user).then(function (response) {
          resolve({ user: user, data: response.data });
        }).catch(function (error) {
          resolve({ user: user, data: new Error(error.response.data) });
        });
      });
    });

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function (responses) {
      var errors = [];
      responses.forEach(function (response) {
        if (response.data instanceof Error) {
          errors.push({ user: response.user, error: response.data });
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_NEW_USER_ID"], { user: response.user, newId: response.data.id });
        }
      });
      return errors;
    }).then(function (errors) {
      if (errors.length > 0) {
        var msg = 'Error(s) on the following user(s): \n';
        errors.forEach(function (x) {
          msg += x.user.firstName + ' ' + x.user.lastName + ': ' + x.error.message + ' \n';
        });

        alert(msg);
      } else {
        alert('Saved successfully!');
      }
    }).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessUser', show: false });
    });
  },
  removeUser: function removeUser(_ref9, user) {
    var commit = _ref9.commit,
        state = _ref9.state;

    state.business.users.splice(state.business.users.indexOf(user), 1);
  },
  resetUserPassword: function resetUserPassword(_ref10, user) {
    var commit = _ref10.commit,
        state = _ref10.state;

    if (user.password === null) {
      alert('Password must be provided.');
      return null;
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var data = {
        password: user.password,
        resetLockout: user.isLockout,
        id: user.userId,
        sid: state.business.sid
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].resetUserPassword(data).then(function (response) {
        alert('User password has been reset successfully!');
        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      });
    });
  },
  upsertBusinessNote: function upsertBusinessNote(_ref11, _ref12) {
    var commit = _ref11.commit,
        state = _ref11.state;
    var note = _ref12.note,
        hasFiles = _ref12.hasFiles;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: true });

    var body = {
      sid: state.business.sid,
      noteId: null,
      text: note.get('note')
    };

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertBusinessNote(body).then(function (response) {
        if (response.status === 200) {
          var dateCreated = new Date().toISOString();

          var newNote = {
            id: parseInt(response.data),
            text: note.get('note'),
            files: null,
            dateCreated: dateCreated
          };
        }
        resolve(newNote);
      }).catch(function (error) {
        alert(error);
        reject(error);
      });
    }).then(function (newNote) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (hasFiles) {
          note.append('commentId', newNote.id);

          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertBusinessDocument(note).then(function (response) {
            commit(__WEBPACK_IMPORTED_MODULE_3__types__["ADD_NOTE_TO_LIST"], newNote);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.business.notes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _note = _step.value;

                if (_note.id === newNote.id) {
                  _note.files = response.data;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: false });
            resolve();
          }).catch(function (error) {
            alert('Something went wrong with the files.');
            reject(error);
          });
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["ADD_NOTE_TO_LIST"], newNote);
          resolve();
        }
      });
    }).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: false });
    });
  },
  upsertBusinessInfo: function upsertBusinessInfo(_ref13) {
    var commit = _ref13.commit,
        state = _ref13.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessInfo', show: true });

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertBusinessInfo(state.business).then(function (response) {
        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessInfo', show: false });
      });
    });
  },
  upsertBusinessBilling: function upsertBusinessBilling(_ref14) {
    var commit = _ref14.commit,
        state = _ref14.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: true });

    var body = state.business.billing;
    body.sid = state.business.sid;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertBusinessBilling(body).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_BILLING"], state.business.billing);

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  upsertBusinessDiscount: function upsertBusinessDiscount(_ref15, _ref16) {
    var commit = _ref15.commit,
        state = _ref15.state;
    var mappingTypeId = _ref16.mappingTypeId,
        otherDescriptorId = _ref16.otherDescriptorId;

    var body = {
      mappingTypeId: mappingTypeId,
      otherDescriptorId: otherDescriptorId,
      products: state.business.discounts,
      sid: state.business.sid
    };

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertBusinessDiscount(body).then(function (response) {
        response.data.forEach(function (x, i) {
          if (!x.success) {
            response.data[i] = state.business.discounts.filter(function (discount) {
              return discount.id === x.id;
            })[0];
            response.data[i].success = false;
          }
        });

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert('Something went wrong!');
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  modifyManufacturer: function modifyManufacturer(_ref17, _ref18) {
    var commit = _ref17.commit;
    var manufacturer = _ref18.manufacturer,
        event = _ref18.event;

    var obj = { id: manufacturer.id, percent: document.getElementById('manufacturer_percent_' + manufacturer.name).value };
    if (event.target.checked) {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["ADD_MANUFACTURER"], obj);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["REMOVE_MANUFACTURER"], obj);
    }
  },
  updateManufacturerPercent: function updateManufacturerPercent(_ref19, _ref20) {
    var commit = _ref19.commit;
    var id = _ref20.id,
        event = _ref20.event;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["UPDATE_MANUFACTURER_PERCENT"], { id: id, percent: event.target.value });
  },
  getDistributors: function getDistributors(_ref21) {
    var commit = _ref21.commit;

    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getDistributors().then(function (response) {
      if (response.status === 200) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_DISTRIBUTORS"], response.data);
      }
    });
  },
  getSalesReps: function getSalesReps(_ref22) {
    var commit = _ref22.commit;

    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getSalesReps().then(function (response) {
      if (response.status === 200) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_SALES_REPS"], response.data);
      }
    });
  },
  addDiscountByVolumeToProduct: function addDiscountByVolumeToProduct(_ref23, productIndex) {
    var commit = _ref23.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT"], productIndex);
  },
  removeDiscountByVolumeToProduct: function removeDiscountByVolumeToProduct(_ref24, _ref25) {
    var commit = _ref24.commit;
    var discountIndex = _ref25.discountIndex,
        productIndex = _ref25.productIndex;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT"], { discountIndex: discountIndex, productIndex: productIndex });
  },
  getBusinessLocation: function getBusinessLocation(_ref26, sid) {
    var commit = _ref26.commit,
        state = _ref26.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getBusinessLocation(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_LOCATION"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessInfo: function getBusinessInfo(_ref27, sid) {
    var commit = _ref27.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getBusinessInfo(sid).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_INFO"], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessUsers: function getBusinessUsers(_ref28, sid) {
    var commit = _ref28.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getBusinessUsers(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USERS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessBilling: function getBusinessBilling(_ref29, sid) {
    var commit = _ref29.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getBusinessBilling(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_BILLING"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessDiscounts: function getBusinessDiscounts(_ref30, _ref31) {
    var commit = _ref30.commit,
        state = _ref30.state;
    var type = _ref31.type,
        other = _ref31.other;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getBusinessDiscounts({ sid: state.business.sid, type: type, other: other }).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_DISCOUNTS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessNotes: function getBusinessNotes(_ref32, sid) {
    var commit = _ref32.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getBusinessNotes(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_NOTES"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getDownloadToken: function getDownloadToken(_ref33, fileId) {
    var commit = _ref33.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getDownloadToken(fileId).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  resetPeriodData: function resetPeriodData(_ref34) {
    var commit = _ref34.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["RESET_PERIOD_DATA"]);
  }
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchKey: function searchKey(state) {
    return state.searchKey;
  },
  activeTab: function activeTab(state) {
    return state.activeTab;
  },
  tabs: function tabs(state) {
    return state.tabs;
  },
  activeMappingType: function activeMappingType(state) {
    return state.activeMappingType;
  },

  business: function business(state) {
    return state.business;
  },

  loading: function loading(state) {
    return state.loading;
  },
  businesses: function businesses(state) {
    return state.businesses;
  },
  distributors: function distributors(state) {
    return state.distributors;
  },
  salesReps: function salesReps(state) {
    return state.salesReps;
  },
  vehicleManufacturers: function vehicleManufacturers(state) {
    return state.vehicleManufacturers;
  },
  insuranceCompanies: function insuranceCompanies(state) {
    return state.insuranceCompanies;
  },
  products: function products(state) {
    return state.products;
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(103);



var _types$INIT_BUSINESS_;



/* harmony default export */ __webpack_exports__["default"] = (_types$INIT_BUSINESS_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["INIT_BUSINESS_DATA"], function (state) {
  state.business = {
    id: 0,
    shopId: '',
    sid: null,
    statusId: null,
    name: null,
    timezone: null,
    phone: null,
    billSameAsPrimary: false,
    dispatchPriorityId: null,
    distributorId: null,
    salesRepId: null,
    referralSourceId: null,
    isMobileClient: false,
    isAstechClient: false,
    isCorporateAccount: false,
    accountId: null,
    annualRevenueId: null,
    monthlyRoId: null,
    locationCountId: null,
    manufacturers: [],
    oemCertifications: [],
    insuranceDepartments: [],
    services: [],
    primaryAddress: {
      id: 0,
      street: null,
      city: null,
      state: null,
      postalCode: null
    },
    billingAddress: {
      id: 0,
      street: null,
      city: null,
      state: null,
      postalCode: null
    },
    users: [],
    billing: {
      isDemo: false,
      isRecurring: false,
      periodId: null,
      periodAmount: null,
      currencyId: null,
      isCurrencyIdSavedInDatabase: false
    },
    discounts: [],
    notes: []
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNT_MODAL"], function (state, modal) {
  state.activeMappingType = modal;
  if (modal === null) {
    state.business.discounts = [];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_LOADING"], function (state, _ref) {
  var button = _ref.button,
      show = _ref.show;

  state.loading[button] = show;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ACTIVE_TAB"], function (state, tab) {
  state.activeTab = tab;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESSES"], function (state, businesses) {
  state.businesses = businesses;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["COPY_BILLING_ADDRESS_FROM_DEFAULT"], function (state, address) {
  state.business.billingAddress = address;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESS_SID"], function (state, sid) {
  state.business.sid = sid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_NEW_USER_TO_LIST"], function (state) {
  state.business.users.push({
    id: 0,
    firstName: null,
    lastName: null,
    hasLogin: false,
    username: null,
    email: null,
    password: null,
    requiresPasswordOnSubmit: false,
    isPrimary: false,
    isEnabled: false,
    isLockout: false,
    isDeleted: false,
    receivesInvoices: false,
    receivesReports: false,
    receivesReportsOnly: false,
    isAstechUser: false,
    titleId: null,
    phone: null
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_NEW_USER_ID"], function (state, _ref2) {
  var user = _ref2.user,
      newId = _ref2.newId;

  var index = state.business.users.findIndex(function (u) {
    return u === user;
  });
  if (state.business.users[index].id === 0) {
    state.business.users[index].id = newId;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MANUFACTURER"], function (state, manufacturer) {
  state.business.manufacturers.push(manufacturer);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["REMOVE_MANUFACTURER"], function (state, manufacturer) {
  var index = state.business.manufacturers.findIndex(function (x) {
    return x.id === manufacturer.id;
  });
  state.business.manufacturers.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["UPDATE_MANUFACTURER_PERCENT"], function (state, _ref3) {
  var id = _ref3.id,
      percent = _ref3.percent;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.business.manufacturers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var manufacturer = _step.value;

      if (manufacturer.id === id) {
        manufacturer.percent = percent;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISTRIBUTORS"], function (state, distributors) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SALES_REPS"], function (state, salesReps) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT"], function (state, productIndex) {
  state.business.discounts[productIndex].discountsByVolume.push({
    id: null,
    typeId: null,
    amount: null,
    volumeBreak: null,
    isActive: true
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT"], function (state, _ref4) {
  var discountIndex = _ref4.discountIndex,
      productIndex = _ref4.productIndex;

  state.business.discounts[productIndex].discountsByVolume.splice(discountIndex, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_LOCATION"], function (state, location) {
  state.business.id = location.id;
  state.business.sid = location.sid;
  state.business.shopId = location.shopId;
  state.business.name = location.name;
  state.business.timezone = location.timezone;
  state.business.phone = location.phone;
  state.business.billSameAsPrimary = location.billSameAsPrimary;
  state.business.primaryAddress = location.primaryAddress;

  state.business.billingAddress = state.business.billSameAsPrimary ? location.primaryAddress : location.billingAddress;
  state.business.billingAddress.state = state.business.billSameAsPrimary ? location.primaryAddress.state : location.billingAddress.state;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_INFO"], function (state, info) {
  if (info) {
    state.business.statusId = info.statusId;
    state.business.annualRevenueId = info.annualRevenueId;
    state.business.dispatchPriorityId = info.dispatchPriorityId;
    state.business.distributorId = info.distributorId;
    state.business.accountId = info.accountId;
    state.business.monthlyRoId = info.monthlyRoId;
    state.business.manufacturers = info.manufacturers || [];
    state.business.services = info.services || [];

    state.business.isCorporateAccount = info.isCorporateAccount;
    state.business.isAstechClient = info.isAstechClient;
    state.business.isMobileClient = info.isMobileClient;
    state.business.salesRepId = info.salesRepId;
    state.business.referralSourceId = info.referralSourceId;
    state.business.locationCountId = info.locationCountId;
    state.business.oemCertifications = info.oemCertifications || [];
    state.business.insuranceDepartments = info.insuranceDepartments || [];
  } else {
    state.business.annualRevenueId = null;
    state.business.dispatchPriorityId = null;
    state.business.distributorId = null;
    state.business.accountId = null;
    state.business.monthlyRoId = null;
    state.business.manufacturers = [];
    state.business.services = [];

    state.business.isAstechClient = false;
    state.business.isMobileClient = false;
    state.business.salesRepId = null;
    state.business.referralSourceId = null;
    state.business.locationCountId = null;
    state.business.oemCertifications = [];
    state.business.insuranceDepartments = [];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USERS"], function (state, users) {
  state.business.users = users || [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BILLING"], function (state, billing) {
  state.business.billing = billing;
  state.business.billing.isCurrencyIdSavedInDatabase = billing.currencyId > 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNTS"], function (state, discounts) {
  state.business.discounts = discounts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_NOTES"], function (state, notes) {
  state.business.notes = notes;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_NOTE_TO_LIST"], function (state, note) {
  state.business.notes.unshift(note);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_PERIOD_DATA"], function (state) {
  state.business.billing.periodId = null;
  state.business.billing.periodAmount = null;
}), _types$INIT_BUSINESS_);

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  searchKey: { value: '' },
  activeTab: 'Location',
  tabs: ['Location', 'Biz Info', 'User List', 'Billing', 'Notes/Files'],
  activeMappingType: null,
  loading: {
    upsertBusiness: false,
    upsertBusinessUser: false,
    upsertBusinessBilling: false,
    upsertBusinessNote: false,
    upsertBusinessInfo: false
  },

  business: {},
  businesses: [],

  products: []
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currency__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dates__ = __webpack_require__(386);



/* harmony default export */ __webpack_exports__["a"] = ({
  currency: __WEBPACK_IMPORTED_MODULE_0__currency__,
  dates: __WEBPACK_IMPORTED_MODULE_1__dates__
});

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(100);





var messages = {};
var files = __webpack_require__(672);

files.keys().forEach(function (path) {
  var languages = files(path);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(languages).forEach(function (lang) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('i18n_addAllowedLang', lang);
    messages[lang] = languages[lang];
  });
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: messages
}));

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var errorHandler = function errorHandler(err, vm, info) {
  console.error(err);
  console.error(vm);
  console.error(info);
};

/* harmony default export */ __webpack_exports__["a"] = (errorHandler);

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var Component = __webpack_require__(361)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(81);


/* harmony default export */ __webpack_exports__["default"] = ({
  authUser: function authUser(credentials, callback, error) {
    __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].auth(credentials, callback, error);
  }
});

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(81);


/* harmony default export */ __webpack_exports__["default"] = ({
  upsertBusiness: function upsertBusiness(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/Upsert', data);
  },
  upsertBusinessUser: function upsertBusinessUser(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/ModifyUsers', data);
  },
  upsertBusinessNote: function upsertBusinessNote(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/UpsertNote', data);
  },
  upsertBusinessDocument: function upsertBusinessDocument(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/AddDocument', data, config);
  },
  upsertBusinessInfo: function upsertBusinessInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/UpsertInfo', data);
  },
  upsertBusinessBilling: function upsertBusinessBilling(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/UpsertBilling', data);
  },
  upsertBusinessDiscount: function upsertBusinessDiscount(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/UpsertDiscount', data);
  },
  resetUserPassword: function resetUserPassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/ResetPassword', data);
  },
  getDownloadToken: function getDownloadToken(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/User/GetDownloadToken', data);
  },
  getBusinesses: function getBusinesses(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Registered', data);
  },
  getBusinessLocation: function getBusinessLocation(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Location?key=' + sid);
  },
  getBusinessInfo: function getBusinessInfo(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Info?key=' + sid);
  },
  getBusinessUsers: function getBusinessUsers(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Users?key=' + sid);
  },
  getBusinessNotes: function getBusinessNotes(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Notes?key=' + sid);
  },
  getBusinessBilling: function getBusinessBilling(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Billing?key=' + sid);
  },
  getBusinessDiscounts: function getBusinessDiscounts(_ref) {
    var sid = _ref.sid,
        type = _ref.type,
        other = _ref.other;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Discounts?key=' + sid + '&type=' + type + '&other=' + other);
  }
});

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(81);


/* harmony default export */ __webpack_exports__["default"] = ({
  lookup: function lookup(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/ByKey', '"' + data + '"', config);
  },
  lookups: function lookups(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/ByKeys', data, config);
  },
  upsertLookup: function upsertLookup(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/Upsert', data);
  },
  upsertProduct: function upsertProduct(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('c/Business/UpsertProduct', data);
  },
  getTimeZones: function getTimeZones() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/TimeZones');
  },
  getDistributors: function getDistributors() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Distributors');
  },
  getSalesReps: function getSalesReps() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/SalesReps');
  },
  getVehicleManufacturers: function getVehicleManufacturers() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/VehicleManufacturers');
  },
  getInsuranceCompanies: function getInsuranceCompanies() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/InsuranceCompanies');
  },
  getProducts: function getProducts() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Products');
  },
  getStates: function getStates() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/StateProvince');
  }
});

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(81);


/* harmony default export */ __webpack_exports__["default"] = ({
  getUsers: function getUsers(code, cb) {
    __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('http://httpstat.us/' + code).then(function (response) {
      cb(response);
    }).catch(function (error) {
      cb(error);
    });
  },
  updateUser: function updateUser(code, cb) {
    __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('http://httpstat.us/' + code).then(function (response) {
      cb(response);
    }).catch(function (error) {
      cb(error);
    });
  }
});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["currencyUSD"] = currencyUSD;
var digitsRE = /(\d{3})(?=\d)/g;

function currencyUSD(value, currency, decimals) {
  var originalValue = value;
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return originalValue;
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["shortDate"] = shortDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function shortDate(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MM/DD/YYYY hh:mm:ssa');
}

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locales__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logger__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_mask__ = __webpack_require__(357);














var favicon = document.getElementById('favicon');
if (window.config.tenant === 'HATA') {
  favicon.href = '/static/hata-favicon-16x16.png';
  document.title = 'HATA | Customer Records';
} else {
  favicon.href = '/static/athena-favicon.ico';
  document.title = 'Athena';
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.errorHandler = __WEBPACK_IMPORTED_MODULE_7__logger__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */]).forEach(function (filter) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */][filter]).forEach(function (f) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter(f, __WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */][filter][f]);
  });
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('disable-all', {
  componentUpdated: function componentUpdated(el, binding) {
    if (!binding.value) {
      return;
    }
    var tags = ['input', 'button', 'textarea', 'select', 'radio-label', 'img'];
    tags.forEach(function (tagName) {
      var nodes = el.getElementsByTagName(tagName);
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].disabled = true;
        nodes[i].tabIndex = -1;
      }
    });
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('paginate', __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_v_mask__["a" /* default */]);

window.app = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_4__locales__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__app___default.a);
  }
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var guardRoute = function guardRoute(to, from, next) {

  var isAuthenticated = localStorage.getItem('token') !== null;

  if (to.matched.some(function (record) {
    return record.meta.allowAnonymous;
  })) {
    next();
  } else if (!isAuthenticated) {
    next('/login');
  } else if (isAuthenticated) {
    next();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (guardRoute);

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(100);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  redirect: function redirect(to) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.loggedUser.role === 'admin') {
      return 'admin/defaults';
    } else {
      return 'business';
    }
  },
  component: function component(resolve) {
    __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(683)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },

  children: [{
    path: 'login',
    component: function component(resolve) {
      __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(682)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },

    meta: { allowAnonymous: true },
    beforeEnter: function beforeEnter(to, from, next) {
      if (localStorage.getItem('token')) {
        next('/');
      } else {
        next();
      }
    }
  }, {
    path: 'business',
    component: function component(resolve) {
      __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(680)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'business/:action/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(679)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/defaults',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(677)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/salesreps',
    component: function component(resolve) {
      __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(678)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: '*',
  component: function component(resolve) {
    __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(681)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },

  meta: { allowAnonymous: true }
}]);

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "admin", function() { return admin; });
var admin = {
  namespaced: true,
  state: {
    salesRepresentatives: []
  },
  getters: {
    salesRepresentatives: function salesRepresentatives(state) {
      return state.salesRepresentatives;
    }
  },
  actions: {},
  mutations: {
    ADD_SALES_REPRESENTATIVE: function ADD_SALES_REPRESENTATIVE(state, defaultTitleId) {
      state.salesRepresentatives.push({
        id: 0,
        firstName: null,
        lastName: null,
        hasLogin: false,
        username: null,
        email: null,
        password: null,
        requiresPasswordOnSubmit: false,
        isEnabled: false,
        isLockout: false,
        receivesInvoices: false,
        receivesReports: false,
        receivesReportsOnly: false,
        isAstechUser: false,
        titleId: defaultTitleId,
        phone: null
      });
    }
  }
};

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);





var auth = {
  state: {
    loggedUser: {
      username: null,
      role: null,
      isSuperAdmin: null
    }
  },
  getters: {
    loggedUser: function loggedUser(state) {
      return state.loggedUser;
    }
  },
  actions: {
    checkAuth: function checkAuth(_ref) {
      var commit = _ref.commit;

      if (!localStorage.getItem('token')) {
        commit('LOGOUT');
      } else {
        commit('SET_USER', localStorage.getItem('token'));
      }
    },
    authUser: function authUser(_ref2, data) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].authUser(data, function (response) {
          commit('SET_USER', response.data);
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    logout: function logout(_ref3) {
      var commit = _ref3.commit;

      commit('LOGOUT');
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
    }
  },
  mutations: {
    SET_USER: function SET_USER(state, token) {
      var permissions = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token).com_astech_perms.find(function (o) {
        return o.per === 'role';
      });
      state.loggedUser.username = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token).prn;

      state.loggedUser.role = 'user';
      if (permissions.flg === 2047) {
        state.loggedUser.isSuperAdmin = true;
      } else {
        state.loggedUser.isSuperAdmin = false;
      }
      localStorage.setItem('token', token);
    },
    LOGOUT: function LOGOUT(state) {
      localStorage.removeItem('token');
      state.loggedUser = { username: null, role: null };
    }
  }
};

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "business", function() { return business; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(160);





var business = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["default"],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locales", function() { return locales; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var defaultLang = __webpack_require__.i({"NODE_ENV":"production"}).defaultLang || window.localStorage.getItem('_lang') || window.app.defaultLang;

var locales = {
  state: {
    i18n_loaded: false,
    i18n_lang: defaultLang,
    i18n_allowedLang: [defaultLang] },
  getters: {
    i18n_lang: function i18n_lang(state) {
      return state.i18n_lang;
    },
    i18n_isValidLang: function i18n_isValidLang(state) {
      return function (lang) {
        return state.i18n_allowedLang.includes(lang);
      };
    },
    i18n_allowedLang: function i18n_allowedLang(state) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(state.i18n_allowedLang)));
    }
  },
  actions: {
    i18n_addAllowedLang: function i18n_addAllowedLang(_ref, lang) {
      var commit = _ref.commit;

      commit('SET_I18N_ALLOWED_LANG', lang);
    },
    i18n_setLang: function i18n_setLang(_ref2, lang) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (!state.i18n_allowedLang.includes(lang)) {
        lang = state.i18n_lang || defaultLang;
      }
      if (lang === state.i18n_lang && state.i18n_loaded) {
        return;
      }
      commit('SET_I18N_LANG', lang);
      commit('SET_I18N_LOADED', true);
    },
    i18n_changeLang: function i18n_changeLang(_ref3, lang) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var path = window.location.pathname.replace(state.i18n_lang, lang);
      console.log(window.location.replace(path));
    }
  },
  mutations: {
    SET_I18N_LANG: function SET_I18N_LANG(state, lang) {},
    SET_I18N_LOADED: function SET_I18N_LOADED(state, loaded) {
      state.i18n_loaded = loaded;
    },
    SET_I18N_ALLOWED_LANG: function SET_I18N_ALLOWED_LANG(state, lang) {
      state.i18n_allowedLang.push(lang);
    }
  }
};

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookup", function() { return lookup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(102);





var lookup = {
  namespaced: true,
  state: {
    lookups: {},
    timezones: [],
    states: [],
    products: [],
    insuranceCompanies: [],
    vehicleManufacturers: []
  },
  getters: {
    lookups: function lookups(state) {
      return state.lookups;
    },
    timezones: function timezones(state) {
      return state.timezones;
    },
    states: function states(state) {
      return state.states;
    },
    insuranceCompanies: function insuranceCompanies(state) {
      return state.insuranceCompanies;
    },
    vehicleManufacturers: function vehicleManufacturers(state) {
      return state.vehicleManufacturers;
    },
    products: function products(state) {
      return state.products;
    }
  },
  actions: {
    getLookups: function getLookups(_ref, keys) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookups(keys, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS', { keys: keys, data: response.data });
          resolve(response);
        });
      });
    },
    upsertLookup: function upsertLookup(_ref2, lookup) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertLookup(lookup).then(function (response) {
          lookup.id = response.data;
          if (response.status === 200) {
            commit('SET_LOOKUP', lookup);
          }
          resolve(response);
        });
      });
    },
    upsertProduct: function upsertProduct(_ref3, product) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertProduct(product).then(function (response) {
          product.id = response.data;
          if (response.status === 200) {
            commit('SET_PRODUCT', product);
          }
          resolve(response);
        });
      });
    },
    getTimeZones: function getTimeZones(_ref4) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getTimeZones().then(function (response) {
          commit('SET_TIMEZONES', response.data);
          resolve(response);
        });
      });
    },
    getStates: function getStates(_ref5) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getStates().then(function (response) {
          commit('SET_STATES', response.data);
          resolve(response);
        });
      });
    },
    getInsuranceCompanies: function getInsuranceCompanies(_ref6) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getInsuranceCompanies().then(function (response) {
        if (response.status === 200) {
          commit('SET_INSURANCE_COMPANIES', response.data);
        }
      });
    },
    getVehicleManufacturers: function getVehicleManufacturers(_ref7) {
      var commit = _ref7.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getVehicleManufacturers().then(function (response) {
        if (response.status === 200) {
          commit('SET_VEHICLE_MANUFATURERS', response.data);
        }
      });
    },
    getProducts: function getProducts(_ref8) {
      var commit = _ref8.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getProducts().then(function (response) {
          commit('SET_PRODUCTS', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  },
  mutations: {
    SET_LOOKUPS: function SET_LOOKUPS(state, _ref9) {
      var keys = _ref9.keys,
          data = _ref9.data;

      if ((typeof keys === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(keys)) === 'object') {
        keys.forEach(function (x) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookups, x, data.filter(function (l) {
            return l.key === x;
          }));
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookups, keys, data);
      }
    },
    SET_LOOKUP: function SET_LOOKUP(state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup);
      } else {
        var index = state.lookups[lookup.key].findIndex(function (i) {
          return i.id === lookup.id;
        });
        state.lookups[lookup.key].splice(index, 1);
      }
    },
    SET_PRODUCT: function SET_PRODUCT(state, product) {
      if (product.isActive) {
        state.products.push(product);
      } else {
        var index = state.products.findIndex(function (i) {
          return i.id === product.id;
        });
        state.products.splice(index, 1);
      }
    },
    SET_TIMEZONES: function SET_TIMEZONES(state, timezones) {
      state.timezones = timezones || [];
    },
    SET_STATES: function SET_STATES(state, states) {
      state.states = states || [];
    },
    SET_INSURANCE_COMPANIES: function SET_INSURANCE_COMPANIES(state, insuranceCompanies) {
      state.insuranceCompanies = insuranceCompanies || [];
    },
    SET_VEHICLE_MANUFATURERS: function SET_VEHICLE_MANUFATURERS(state, vehicleManufacturers) {
      state.vehicleManufacturers = vehicleManufacturers || [];
    },
    SET_PRODUCTS: function SET_PRODUCTS(state, products) {
      state.products = products || [];
    }
  }
};

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(152);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('business', ['business'])),
  created: function created() {
    this.$store.dispatch('checkAuth');
  }
});

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 217,
	"./af.js": 217,
	"./ar": 224,
	"./ar-dz": 218,
	"./ar-dz.js": 218,
	"./ar-kw": 219,
	"./ar-kw.js": 219,
	"./ar-ly": 220,
	"./ar-ly.js": 220,
	"./ar-ma": 221,
	"./ar-ma.js": 221,
	"./ar-sa": 222,
	"./ar-sa.js": 222,
	"./ar-tn": 223,
	"./ar-tn.js": 223,
	"./ar.js": 224,
	"./az": 225,
	"./az.js": 225,
	"./be": 226,
	"./be.js": 226,
	"./bg": 227,
	"./bg.js": 227,
	"./bm": 228,
	"./bm.js": 228,
	"./bn": 230,
	"./bn-bd": 229,
	"./bn-bd.js": 229,
	"./bn.js": 230,
	"./bo": 231,
	"./bo.js": 231,
	"./br": 232,
	"./br.js": 232,
	"./bs": 233,
	"./bs.js": 233,
	"./ca": 234,
	"./ca.js": 234,
	"./cs": 235,
	"./cs.js": 235,
	"./cv": 236,
	"./cv.js": 236,
	"./cy": 237,
	"./cy.js": 237,
	"./da": 238,
	"./da.js": 238,
	"./de": 241,
	"./de-at": 239,
	"./de-at.js": 239,
	"./de-ch": 240,
	"./de-ch.js": 240,
	"./de.js": 241,
	"./dv": 242,
	"./dv.js": 242,
	"./el": 243,
	"./el.js": 243,
	"./en-au": 244,
	"./en-au.js": 244,
	"./en-ca": 245,
	"./en-ca.js": 245,
	"./en-gb": 246,
	"./en-gb.js": 246,
	"./en-ie": 247,
	"./en-ie.js": 247,
	"./en-il": 248,
	"./en-il.js": 248,
	"./en-in": 249,
	"./en-in.js": 249,
	"./en-nz": 250,
	"./en-nz.js": 250,
	"./en-sg": 251,
	"./en-sg.js": 251,
	"./eo": 252,
	"./eo.js": 252,
	"./es": 256,
	"./es-do": 253,
	"./es-do.js": 253,
	"./es-mx": 254,
	"./es-mx.js": 254,
	"./es-us": 255,
	"./es-us.js": 255,
	"./es.js": 256,
	"./et": 257,
	"./et.js": 257,
	"./eu": 258,
	"./eu.js": 258,
	"./fa": 259,
	"./fa.js": 259,
	"./fi": 260,
	"./fi.js": 260,
	"./fil": 261,
	"./fil.js": 261,
	"./fo": 262,
	"./fo.js": 262,
	"./fr": 265,
	"./fr-ca": 263,
	"./fr-ca.js": 263,
	"./fr-ch": 264,
	"./fr-ch.js": 264,
	"./fr.js": 265,
	"./fy": 266,
	"./fy.js": 266,
	"./ga": 267,
	"./ga.js": 267,
	"./gd": 268,
	"./gd.js": 268,
	"./gl": 269,
	"./gl.js": 269,
	"./gom-deva": 270,
	"./gom-deva.js": 270,
	"./gom-latn": 271,
	"./gom-latn.js": 271,
	"./gu": 272,
	"./gu.js": 272,
	"./he": 273,
	"./he.js": 273,
	"./hi": 274,
	"./hi.js": 274,
	"./hr": 275,
	"./hr.js": 275,
	"./hu": 276,
	"./hu.js": 276,
	"./hy-am": 277,
	"./hy-am.js": 277,
	"./id": 278,
	"./id.js": 278,
	"./is": 279,
	"./is.js": 279,
	"./it": 281,
	"./it-ch": 280,
	"./it-ch.js": 280,
	"./it.js": 281,
	"./ja": 282,
	"./ja.js": 282,
	"./jv": 283,
	"./jv.js": 283,
	"./ka": 284,
	"./ka.js": 284,
	"./kk": 285,
	"./kk.js": 285,
	"./km": 286,
	"./km.js": 286,
	"./kn": 287,
	"./kn.js": 287,
	"./ko": 288,
	"./ko.js": 288,
	"./ku": 289,
	"./ku.js": 289,
	"./ky": 290,
	"./ky.js": 290,
	"./lb": 291,
	"./lb.js": 291,
	"./lo": 292,
	"./lo.js": 292,
	"./lt": 293,
	"./lt.js": 293,
	"./lv": 294,
	"./lv.js": 294,
	"./me": 295,
	"./me.js": 295,
	"./mi": 296,
	"./mi.js": 296,
	"./mk": 297,
	"./mk.js": 297,
	"./ml": 298,
	"./ml.js": 298,
	"./mn": 299,
	"./mn.js": 299,
	"./mr": 300,
	"./mr.js": 300,
	"./ms": 302,
	"./ms-my": 301,
	"./ms-my.js": 301,
	"./ms.js": 302,
	"./mt": 303,
	"./mt.js": 303,
	"./my": 304,
	"./my.js": 304,
	"./nb": 305,
	"./nb.js": 305,
	"./ne": 306,
	"./ne.js": 306,
	"./nl": 308,
	"./nl-be": 307,
	"./nl-be.js": 307,
	"./nl.js": 308,
	"./nn": 309,
	"./nn.js": 309,
	"./oc-lnc": 310,
	"./oc-lnc.js": 310,
	"./pa-in": 311,
	"./pa-in.js": 311,
	"./pl": 312,
	"./pl.js": 312,
	"./pt": 314,
	"./pt-br": 313,
	"./pt-br.js": 313,
	"./pt.js": 314,
	"./ro": 315,
	"./ro.js": 315,
	"./ru": 316,
	"./ru.js": 316,
	"./sd": 317,
	"./sd.js": 317,
	"./se": 318,
	"./se.js": 318,
	"./si": 319,
	"./si.js": 319,
	"./sk": 320,
	"./sk.js": 320,
	"./sl": 321,
	"./sl.js": 321,
	"./sq": 322,
	"./sq.js": 322,
	"./sr": 324,
	"./sr-cyrl": 323,
	"./sr-cyrl.js": 323,
	"./sr.js": 324,
	"./ss": 325,
	"./ss.js": 325,
	"./sv": 326,
	"./sv.js": 326,
	"./sw": 327,
	"./sw.js": 327,
	"./ta": 328,
	"./ta.js": 328,
	"./te": 329,
	"./te.js": 329,
	"./tet": 330,
	"./tet.js": 330,
	"./tg": 331,
	"./tg.js": 331,
	"./th": 332,
	"./th.js": 332,
	"./tk": 333,
	"./tk.js": 333,
	"./tl-ph": 334,
	"./tl-ph.js": 334,
	"./tlh": 335,
	"./tlh.js": 335,
	"./tr": 336,
	"./tr.js": 336,
	"./tzl": 337,
	"./tzl.js": 337,
	"./tzm": 339,
	"./tzm-latn": 338,
	"./tzm-latn.js": 338,
	"./tzm.js": 339,
	"./ug-cn": 340,
	"./ug-cn.js": 340,
	"./uk": 341,
	"./uk.js": 341,
	"./ur": 342,
	"./ur.js": 342,
	"./uz": 344,
	"./uz-latn": 343,
	"./uz-latn.js": 343,
	"./uz.js": 344,
	"./vi": 345,
	"./vi.js": 345,
	"./x-pseudo": 346,
	"./x-pseudo.js": 346,
	"./yo": 347,
	"./yo.js": 347,
	"./zh-cn": 348,
	"./zh-cn.js": 348,
	"./zh-hk": 349,
	"./zh-hk.js": 349,
	"./zh-mo": 350,
	"./zh-mo.js": 350,
	"./zh-tw": 351,
	"./zh-tw.js": 351
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 662;

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./auth.js": 381,
	"./business.js": 382,
	"./lookup.js": 383,
	"./user.js": 384
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin/index.js": 390,
	"./auth/index.js": 391,
	"./business/actions.js": 158,
	"./business/getters.js": 159,
	"./business/index.js": 392,
	"./business/mutations.js": 160,
	"./business/state.js": 161,
	"./business/types.js": 103,
	"./locales/index.js": 393,
	"./lookup/index.js": 394
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 673,
	"./es.json": 674
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 672;

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

module.exports = {"en":{"message":{"hello":"hello world!"}}}

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

module.exports = {"es":{"message":{"hello":"hola mundo!"}}}

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






var http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create();
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  auth: function auth(data, callback, error) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(window.config.authService, data).then(callback).catch(error);
  },
  get: function get(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + window.config.apiUrl + endpoint, data);
  },
  post: function post(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('' + window.config.apiUrl + endpoint, data, config);
  }
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype, { $http: {
    get: function get() {
      return http;
    }
  } });

/***/ })

},[387]);


// WEBPACK FOOTER //
// static/js/app.a6f8be08122c9f9cfd37.js